import MobileAppScreen from '../screens/MobileApp'
import AppMobileAppScreen from '../screens/App-MobileApp'
import { NextPage } from 'next'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const MobileApp: NextPage = () => {
  const { showDesktopUI } = ScreenWidthPort()

  return (
    <>
      {showDesktopUI ? (<MobileAppScreen />) : (<AppMobileAppScreen />)}
    </>
  )
}
